import { onMounted, onUnmounted } from 'vue'
import {
  NotificationType,
  useNotificationStore
} from '@/store/notificationStore'

/**
 * ネットワーク状態を監視し、オフライン時に通知を表示する
 */
export const useNetworkStatus = () => {
  const notificationStore = useNotificationStore()

  const handleOffline = () => {
    notificationStore.showNotification(
      'ネットワークに接続していません。インターネット接続をご確認ください。',
      NotificationType.Error,
      false // autoClose を false にして消えないようにする
    )
  }

  const handleOnline = () => {
    // オンラインに戻ったら通知を非表示にする
    notificationStore.hideNotification()
  }

  onMounted(() => {
    // 初回マウント時にオフラインかチェック
    if (!navigator.onLine) {
      handleOffline()
    }

    // イベントリスナーを登録
    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)
  })

  onUnmounted(() => {
    // コンポーネントがアンマウントされたらイベントリスナーを削除
    window.removeEventListener('offline', handleOffline)
    window.removeEventListener('online', handleOnline)
  })
}
